<template>
  <div class="min-full">
    <slot name="header">
      <yq-title
        v-if="showTitle"
        :title="title"
        :fullPage="true"
        :warpHeight="true"
        :shareInfo="shareInfo"
        :openInWebPage="openInWebPage"
        :point="point"
        :share="share"
        :logo="logo"
        :titleMaxWidth="titleMaxWidth"
        v-bind="$attrs"
        @titleInit="titleInit"
        @back="titleBack"
        ref="title"
      ></yq-title>
    </slot>
    <div class="content">
      <slot></slot>
    </div>
    <yq-list-bottom ref="bottom" v-if="showBottom" />
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    point: String,
    shareInfo: {
      type: Object,
      default: () => {},
    },
    share: {
      type: Boolean,
      default: true,
    },
    logo: {
      type: Boolean,
      default: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    openInWebPage: {
      type: Boolean,
      default: false,
    },
    defaultShowBottom: {
      type: Boolean,
      default: false,
    },
    titleMaxWidth: {
      type: Number,
      default: 130,
    },
  },
  data() {
    return {
      showBottom: this.defaultShowBottom,
    };
  },
  methods: {
    titleInit() {
      if (!this.showTitle) return;
      this.$emit('titleInit', this.$refs.title.$el.clientHeight ?? 44);
    },
    titleBack() {
      this.$emit('back');
    },
  },
};
</script>

<style scoped lang="less">
.content {
  flex: 1;
  position: relative;
}
.yq-list-bottom {
  margin-top: 52px;
}
</style>
